// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"946":"a1ec34ec","962":"aee3e3ab"}[chunkId] + ".chunk.js";
};